import React, { Component } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import AccountsItem from "./AccountsItem";
import NoData from "./NoData";

export class AccountsList extends Component {
  render() {
    return (
      <>
        <Grid container mb={1} justifyContent="space-between">
          <Grid item>
            <Typography gutterBottom variant="h6">
              {this.props.heading}
            </Typography>
          </Grid>
          <Grid item justifyContent={"end"}>
            <Typography
              variant="h3"
              display="flex"
              justifyContent={"end"}
              flexDirection={this.props.prefix === "£" ? "row-reverse" : "row"}
            >
              <span style={{ fontWeight: 800, fontSize: "1rem" }}>
                {this.props.heading}
              </span>
            </Typography>
            {/* <Typography
              color="text.secondary"
              textAlign="right"
              variant="body2"
            >
              {this.props.subheading}
            </Typography> */}
          </Grid>
        </Grid>

        {this.props.accountDetails && this.props.accountDetails.length ? (
          this.props.accountDetails.map((account, index) => {
            console.log(account, "sdajksailkdjsladjasjdl");
            return (
              <AccountsItem
                handleItemClick={this.props.handleListClick}
                key={account.id}
                prefix={this.props.prefix}
                transaction={account}
                gid={this.props.gid}
                openDialog={this.props.handleOpen}
                // connectionId={this.props.connectionId}
              />
            );
          })
        ) : !this.props.showNoDataMessage ? (
          <NoData text={"No Account Details Found"} gutterBottom />
        ) : null}
      </>
    );
  }
}

export default AccountsList;
